export default __webpack_public_path__ + "static/media/aboutPic.c07c06d8.jpg";